import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SafeHTML from '../SafeHTML';
import CustomPropTypes from '../../utils/customPropTypes';
import ButtonLink from '../ButtonLink';
import scrollToElement from 'scroll-to-element';
import style from '../../../scss/components/GenericBanner/Banner';
import ImageBlock from '../ImageBlock';
import hl_logo from '../../../img/hl_logo.png'

export default class GenericBanner extends React.Component {
  static ControlTypes = {
    "IntroHero": "banner banner-hero banner-center banner-hero-sm",
    "LeftAlignedHero": "banner banner-left banner-hero banner-mobile-stacked",
    "CenteredAlignedCard": "banner banner-center banner-card hide-desc-mobile",
    "LeftAlignedCard": "banner banner-left banner-card hide-desc-mobile",
    "LeftAlignedPrefooter": "banner banner-left banner-sm banner-pre-footer",
    "CenteredPrefooter": "banner banner-center banner-sm banner-pre-footer",
    "RightAlignedHero": "banner banner-right banner-hero hide-desc-mobile",
    "HeroGridCard": "banner banner-left banner-hero-grid",
    "Error": "error"
  }
  static propTypes = {
    image: CustomPropTypes.Image,
    mobileImage: CustomPropTypes.Image,
    eyebrow: PropTypes.string,
    description: PropTypes.string,
    title: PropTypes.string,
    video: PropTypes.object,
    button: PropTypes.object,
    link: PropTypes.object,
    controlType: PropTypes.string,
    showJumpLink: PropTypes.bool,
    showBackLink: PropTypes.bool
  }


  constructor(props) {
    super(props);

    this.mobile = window.matchMedia('(max-width: 768px)'),
      this.desktop = window.matchMedia('(min-width: 769px)');

    this.state = {
      isMobile: false,
    };

    if (this.mobile.matches) this.state.isMobile = true;

    if (this.desktop.matches) this.state.isMobile = false;

  }


  componentDidMount() {
    this._isMounted = true;
    this.mobile.addListener((e) => {
      if (e.matches && this._isMounted) {
        this.setState({ isMobile: true });
      }
    });
    this.desktop.addListener((e) => {
      if (e.matches && this._isMounted) this.setState({ isMobile: false });
    })
  }
  componentWillUnmount() {
    this._isMounted = false;
  }


  getBannerImageProp = () => {
    var img = {};
    if (this.state.isMobile && this.props.mobileImage) {
      img.url = this.props.mobileImage.url;
    }
    else if (this.props.image) {
      img.url = this.props.image.url;
    }
    img.title = this.props.eyebrow;
    return img;
  }

  onButtonClick = (e) => {
    e.preventDefault();
    let el = document.querySelector('.main > section:nth-of-type(2)');
    scrollToElement(el);
  }
  getClassname = (suffix = '') => {
    let cls = this.props.controlType + `${suffix}`;
    if (this.props.className) {
      cls = cls + ` ${this.props.className}${suffix}`
    }
    if (this.props.video)
      cls = cls + " has-video"
    return cls;
  }
  getGoToParentLink = () => {
    if (this.props.showBackLink) {
      var parentPage = document.querySelector('body').getAttribute('parent-page');
      if (parentPage) {
        var [url, title] = parentPage.split(';');
        return <div className="has-back-link">
          <div className="container"><a href={url} className="btn btn-link-normal btn-back-link">
            <i className="icon icon-prev"></i>&nbsp;{title}
          </a></div>
        </div>
      }
    }
    return null;
  }
  render() {
    return (
      <section className={this.getClassname()}>
        {this.props.image && <div className="banner-object">
          <ImageBlock image={this.getBannerImageProp()} imgClassName="object-embed" addWrapper={false} addImageAsBg={true}></ImageBlock>
        </div>
        }
        {this.props.video && <div className="banner-object">
          <video width="100%" height="100%" className="object-embed desktop-show" playsInline autoPlay muted loop>
          <source src={this.props.video.url} type="video/mp4" />

          {/* <source src="https://hunterlab-staging.s3.amazonaws.com/media/documents/Desktop_video_HL.mp4" type="video/mp4" /> */}
            Your browser does not support the video tag.
          </video>
          <div className="logo-container-new mobile-show">
            <img src={hl_logo} className="hl-logo-new"/>
          </div>
          <video width="100%" height="100%" className="object-embed mobile-show" playsInline autoPlay muted loop>
          {/* <source src={this.props.video.url} type="video/mp4" /> */}

          <source src="https://hunterlab-chinese-prod.s3.ap-east-1.amazonaws.com/media/documents/Mobile_Video_HL.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        }
        {this.getGoToParentLink()}
        <div className="banner-container-new">
        <div id={this.props.eyebrow} className="container banner-wrapper">
          <div className="banner-inner">
            {this.props.eyebrow && <h5 className="hunterlab-title banner-title">
              {this.props.eyebrow}
            </h5>
            }

            <div className="banner-main-title">	
              <SafeHTML>{this.props.title}</SafeHTML>	
            </div>

            {this.props.description && <div className="banner-desc">
              <SafeHTML>
                {this.props.description}
              </SafeHTML>
            </div>}

            {this.props.button && (this.props.button.text && (
              <ButtonLink className="btn banner-btn" {...this.props.button} />
            ))}

            {this.props.link && (this.props.link.text && (
              <ButtonLink className="btn btn-link banner-btn" {...this.props.link} />
            ))}
            {this.props.showJumpLink && <a
            href="#"
            className="btn btn-circle btn-scrollToBottom"
            onClick={this.onButtonClick}>
            <i className="icon icon-down"></i>
          </a>}
          </div>
          {this.props.children}
        </div>
        </div>
      </section>
    )
  }

}
